module.exports = __webpack_public_path__ + "static/media/ring.6bfd967f.svg";